import React from "react";
import IComponentSelect from "react-common-components/dist/components/Select/interface";
import Select from "src/components/Select";
import { useTranslation } from "src/context/Translations/context";
import { GroupersOccurrence } from "src/pages/Occurrences/Panel/interface";

const LovGrouperOccurrences: React.FC<Omit<IComponentSelect, "options">> = ({
	name,
	label,
	control,
	...rest
}) => {
	const {translate} = useTranslation();
	return (<Select 
		name={name}
		control={control}
		label={label ?? translate("Agrupadores")}
		options={[
			{ value: GroupersOccurrence.REQUIREMENT, label: `${translate("Requisito")}`},
			{ value: GroupersOccurrence.ORIGIN, label: `${translate("Origem")}`},
			{ value: GroupersOccurrence.CATEGORY, label: `${translate("Categoria")}`},
			{ value: GroupersOccurrence.RESPONSABLE, label: `${translate("Responsável")}`},
			{ value: GroupersOccurrence.REQUIREMENT_ORIGIN, label: `${translate("Requisito")} -> ${translate("Origem")}`},
			{ value: GroupersOccurrence.ORIGIN_CATEGORY, label: `${translate("Origem")} -> ${translate("Categoria")}`},
			{ value: GroupersOccurrence.REQUIREMENT_ORIGIN_CATEGORY, label: `${translate("Requisito")} -> ${translate("Origem")} -> ${translate("Categoria")}`}	,
			{ value: GroupersOccurrence.SECTOR, label: `${translate("Setor")}`},
			{ value: GroupersOccurrence.STEP, label: `${translate("Etapa")}`}
		]}
		{...rest}
	/>);
};

export default LovGrouperOccurrences;
